import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ApiProvider } from './context/ApiContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppDataProvider } from './context/AppDataContext';
import PageLoader from './components/PageLoader';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ApiProvider>
        <Suspense fallback={<PageLoader />}>
          <AppDataProvider>
              <BrowserRouter basename="/app">
                <App />
              </BrowserRouter>
          </AppDataProvider>
        </Suspense>
      </ApiProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
